import { useEffect, useRef, useState } from "react";

import LeftUppperContainer from "./LeftUpperContainer";
import RightUpperContainer from "./RightUpperContainer";

export default function UpperContainer() {
  const leftUpperContainerRef = useRef(null);
  const [leftUpperContainerHeight, setLeftUpperContainerHeight] = useState(0);

  useEffect(() => {
    if (!leftUpperContainerRef.current) {
      return undefined;
    }

    const leftUpperContainerNode = leftUpperContainerRef.current;
    let animationFrameId = null;
    let lastMeasuredHeight = -1;

    const scheduleHeightCommit = (nextHeight) => {
      if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
      }

      animationFrameId = requestAnimationFrame(() => {
        setLeftUpperContainerHeight((previousHeight) =>
          previousHeight === nextHeight ? previousHeight : nextHeight
        );
      });
    };

    const measureHeight = (entryHeight) => {
      const nextHeight = Math.ceil(entryHeight ?? leftUpperContainerNode.offsetHeight ?? 0);

      if (nextHeight === lastMeasuredHeight) {
        return;
      }

      lastMeasuredHeight = nextHeight;
      scheduleHeightCommit(nextHeight);
    };

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      const borderBoxSize = Array.isArray(entry?.borderBoxSize)
        ? entry.borderBoxSize[0]
        : entry?.borderBoxSize;

      measureHeight(borderBoxSize?.blockSize ?? entry?.contentRect?.height);
    });

    measureHeight();
    resizeObserver.observe(leftUpperContainerNode);

    return () => {
      if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
      }
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="contents lg:contents">
        <div ref={leftUpperContainerRef} className="self-start">
          <LeftUppperContainer variant="summary" />
        </div>
        <RightUpperContainer
          variant="medical-breakdown"
          targetHeight={leftUpperContainerHeight}
        />
        <LeftUppperContainer variant="attorney" />
        <RightUpperContainer variant="fee-schedule-calculator" />
      </div>
    </div>
  );
}
